import { Hidden } from '@material-ui/core';
import React from 'react';

const Visible = ({ only, xsUp, smUp, xsDown, smDown, mdUp, ...props }) => {
  let smUpH, xsDownH, smDownH, mdUpH;
  if (smUp) xsDownH = true;
  if (xsDown) smUpH = true;
  if (smDown) mdUpH = true;
  if (mdUp) smDownH = true;
  if (only === 'xs') smUpH = true;
  if (only === 'sm') (xsDownH = true), (mdUpH = true);
  return (
    <Hidden smUp={smUpH} xsDown={xsDownH} smDown={smDownH} mdUp={mdUpH}>
      {props.children}
    </Hidden>
  );
};
export default Visible;
